import React from 'react';
import Layout from 'Components/Layout';
import RuleGroupConditionsForm from 'Components/RuleGroupConditionsForm';

const CreateRuleGroupLayout = () => {
    return (
        <Layout>
            <RuleGroupConditionsForm />
        </Layout>
    );
};

export default CreateRuleGroupLayout;
